'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const CalendarSyncIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="CalendarSyncIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Calendar-Refresh--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Calendar Refresh Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="m15 18.501 -3.5 0 0 3.5"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M22.917 19.734A5.572 5.572 0 0 1 12.1 18.5"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m20 16.501 3.5 0 0 -3.5"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M12.083 15.268A5.572 5.572 0 0 1 22.9 16.5"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M9.5 18.5h-8a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h18a1 1 0 0 1 1 1V10"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m5.5 0.501 0 5"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m15.5 0.501 0 5"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m0.5 7.501 20 0"
          fill="none"
          stroke="#333333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

CalendarSyncIcon.propTypes = {
  sx: PropTypes.object
}
